import { useContext } from 'react';
import { Button, Upload, message } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { settingPictures } from '@/api/personCenter/organization';
import { commonUpload } from '@/api/common';
import { LoadingContext } from '&/components/LoadingComponent';
import './index.scss';

export default function LogoSettings(props) {
    const { disabled = false } = props;
    const loadingContext = useContext(LoadingContext);

    const getChildBySlot = slot => {
        if (Array.isArray(props.children)) {
            return props.children.filter(child => child.props.slot === slot)[0];
        } else if (props.children.props.slot === slot) {
            return props.children;
        }
    };

    const acceptList = ['.jpg', '.jpeg', '.png', '.bmp', '*'];
    const uploadConfig = {
        accept: acceptList.join(','),
        disabled,
        beforeUpload(file) {
            loadingContext.toggleSpin();
            const SUFFIX = file.name
                .substring(file.name.lastIndexOf('.'))
                .toLowerCase();
            if (!acceptList.includes(SUFFIX)) {
                message.error(
                    intl.get('logoSettings.message.prompt.suffixError')
                );
                loadingContext.toggleSpin();
                return false;
            }
            const MAX_SIZE = 1024 * 1024;
            if (file.size > MAX_SIZE) {
                message.error(intl.get('logoSettings.message.prompt.overSize'));
                loadingContext.toggleSpin();
                return false;
            }
            return true;
        },
        customRequest: ({ file, onSuccess, onError }) => {
            const fr = new FileReader();
            const image = new Image();
            fr.onload = res => {
                image.src = res.target.result;
                image.onload = () => {
                    // if (image.width > 400 || image.height > 400) {
                    //     message.error(
                    //         intl.get('logoSettings.message.prompt.overLimit')
                    //     );
                    //     loadingContext.toggleSpin();
                    //     return;
                    // }

                    const formData = new FormData();
                    formData.append('file', file);
                    formData.append('type', '1');
                    formData.append('fileName', file.name);
                    formData.append('blobNum', '1');
                    formData.append('totalBlobNum', '1');
                    commonUpload(formData)
                        .then(res => {
                            const { data } = res;
                            if (data) {
                                const { filePath, fileLink } = data;
                                return settingPictures({
                                    imgPath: filePath,
                                    type: props.type,
                                    dap: 2,
                                }).then(_ => {
                                    message.success(
                                        intl.get(
                                            'logoSettings.message.prompt.successMessage'
                                        )
                                    );
                                    props.callback && props.callback(fileLink);
                                    onSuccess();
                                });
                            }
                        })
                        .catch(onError)
                        .finally(() => {
                            loadingContext.toggleSpin();
                        });
                };
                image.onerror = error => {
                    message.error(
                        intl.get('logoSettings.message.prompt.errorMessage')
                    );
                    loadingContext.toggleSpin();
                };
            };
            fr.readAsDataURL(file);
        },
        defaultFileList: [],
        showUploadList: false,
    };

    return (
        <div className="logo-setting-container">
            <div className="upload-wrap">
                <Upload {...uploadConfig}>
                    <Button
                        className="upload-button"
                        disabled={disabled}
                        icon={<PlusOutlined />}
                    />
                </Upload>
            </div>
            <div className="notice-wrap">{getChildBySlot('notice')}</div>
            <div className="logo-preview-wrap">{getChildBySlot('preview')}</div>
        </div>
    );
}
